import React from "react";
import { Link } from "react-router-dom";

function IndustrySection() {
  return (
    <section className="section industry-section" id="industries">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-subtitle">Our Expertise</span>
          <h2>Industry-Specific Solutions</h2>
          <p className="section-description">
            Tailored streaming solutions for your industry's unique challenges
          </p>
        </div>

        <div className="industry-grid">
          {/* Industry 1 */}
          <div
            className="industry-card"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="industry-icon">
              <i className="fas fa-university"></i>
            </div>
            <h3>Banking &amp; Financial Services</h3>
            <p>
              Real-time fraud detection, transaction monitoring, and regulatory
              compliance for the financial sector.
            </p>
            <ul className="industry-features">
              <li>Real-time transaction monitoring</li>
              <li>Fraud detection &amp; prevention</li>
              <li>Regulatory compliance (RBI, SEBI, PCI-DSS)</li>
              <li>Customer 360° view</li>
            </ul>
            <Link 
              to="/contact" 
              className="btn btn-outline"
              style={{ 
                cursor: 'pointer',
                pointerEvents: 'auto',
            }}
            >
              Learn More
            </Link>
          </div>

          {/* Industry 2 */}
          <div
            className="industry-card"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <div className="industry-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Cybersecurity &amp; SOC</h3>
            <p>
              Advanced threat detection and security operations center (SOC)
              modernization with real-time analytics.
            </p>
            <ul className="industry-features">
              <li>SIEM optimization</li>
              <li>Threat intelligence integration</li>
              <li>Anomaly detection</li>
              <li>Incident response automation</li>
            </ul>
            <Link 
              to="/contact" 
              className="btn btn-outline"
              style={{ 
                cursor: 'pointer',
                pointerEvents: 'auto',
            }}
            >
              Learn More
            </Link>
          </div>

          {/* Industry 3 */}
          <div
            className="industry-card"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="industry-icon">
              <i className="fas fa-landmark"></i>
            </div>
            <h3>Government &amp; PSU</h3>
            <p>
              Secure, sovereign data streaming solutions for government and
              public sector enterprises.
            </p>
            <ul className="industry-features">
              <li>Air-gapped deployments</li>
              <li>Data sovereignty compliance</li>
              <li>Multi-agency data sharing</li>
              <li>Critical infrastructure monitoring</li>
            </ul>
            <Link 
              to="/contact" 
              className="btn btn-outline"
              style={{ 
                cursor: 'pointer',
                pointerEvents: 'auto',
            }}
            >
              Learn More
            </Link>
          </div>

          {/* Industry 4 */}
          <div
            className="industry-card"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <div className="industry-icon">
              <i className="fas fa-mobile-alt"></i>
            </div>
            <h3>Telecom</h3>
            <p>
              High-volume event processing for telecom operators and service
              providers.
            </p>
            <ul className="industry-features">
              <li>Network performance monitoring</li>
              <li>Customer experience analytics</li>
              <li>5G infrastructure support</li>
              <li>Real-time billing &amp; charging</li>
            </ul>
            <Link 
              to="/contact" 
              className="btn btn-outline"
              style={{ 
                cursor: 'pointer',
                pointerEvents: 'auto',
            }}
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IndustrySection;
